import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing');

// Minimal routing without a library — there are exactly two views.
const isAdmin = window.location.pathname.startsWith('/admin');

/**
 * The admin console is loaded on demand, not bundled with the app.
 *
 * It used to be a static import, so every user downloaded the full console on
 * every visit: field names, endpoint paths, the shape of every admin call — a
 * ready-made map of an API they must never reach. The console is only as
 * secure as its token; there is no reason to hand out the map as well.
 *
 * Two effects: the main bundle gets smaller for everyone, and the admin code
 * is only ever requested by someone who opens /admin. With ADMIN_CONSOLE=false
 * nginx answers that path with 404, so the chunk is not served at all.
 */
const AdminPanel = lazy(async () => ({
  default: (await import('./admin/AdminPanel.js')).AdminPanel,
}));

createRoot(root).render(
  <StrictMode>
    {isAdmin ? (
      <Suspense fallback={null}>
        <AdminPanel />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>,
);
